import { useCallback, useState } from "react";
import { type GridApi, type SelectionChangedEvent } from "ag-grid-community";
import { CURRENT_CASE_ROW_CLASS } from "./constants";
import { type FatcaPositionRow } from "./gridConfig";

export const useCrsGridSelection = () => {
  const [selectedPositionIds, setSelectedPositionIds] = useState<string[]>([]);
  const [selectedRowCount, setSelectedRowCount] = useState(0);

  const handleSelectionChanged = useCallback(
    (event: SelectionChangedEvent<FatcaPositionRow>) => {
      let reselected = false;
      event.api.forEachNode((node) => {
        if (node.data?.isCurrentCase && !node.isSelected()) {
          node.setSelected(true);
          reselected = true;
        }
      });
      if (reselected) return;

      const selected = event.api.getSelectedRows();
      setSelectedRowCount(selected.length);
      setSelectedPositionIds(selected.flatMap((r) => (r.positionId ? [r.positionId] : [])));
    },
    [],
  );

  const handleRowDataUpdated = useCallback((event: { api: GridApi<FatcaPositionRow> }) => {
    event.api.forEachNode((node) => {
      if (node.data?.isCurrentCase && !node.isSelected()) {
        node.setSelected(true);
      }
    });
  }, []);

  const getRowClass = useCallback(
    (params: { data?: FatcaPositionRow }) =>
      params.data?.isCurrentCase ? CURRENT_CASE_ROW_CLASS : undefined,
    [],
  );

  return {
    selectedPositionIds,
    selectedRowCount,
    handleSelectionChanged,
    handleRowDataUpdated,
    getRowClass,
  };
};
